import Checkers from "../../../../../../helpers/class/Checkers";
import { useT } from '../../../../../../helpers/i18n';

interface MediaSectionInterface {
    threesixtyTour?: string
    factsheetDocument?: string
}

export const MediaSection = ( {factsheetDocument, threesixtyTour} : MediaSectionInterface ) => {
  const t = useT();
    const hasThreesixtyTour = Checkers.isValidString(threesixtyTour) && threesixtyTour != '0';
    const hasFactsheet = Checkers.isValidString(factsheetDocument);

    if ( !hasThreesixtyTour && !hasFactsheet ) {
        return null;
    }

    return (
        <>
            <div id="pro_detail_factsheets" className="row full-width no-margin pb-5">
                <div className="row">
                    {
                        Checkers.isValidString(threesixtyTour) && threesixtyTour!='0' ?
                            <>
                                <div className="col-sm-6">
                                    <a href={threesixtyTour} target="_blank" rel="noreferrer" className="text-master">
                                        <div className="">
                                            <div
                                                className="profile-img-wrapper m-t-5 d-flex justify-content-center align-items-center b-grey b-a"
                                                style={{width: '55px', height: '55px'}}>
                                                <i className="fa fa-regular fa-panorama fa-2x hint-text"></i>
                                                <div className="chat-status available"></div>
                                            </div>
                                            <div className="inline m-l-10">
                                                <p className="hint-text m-t-10"><strong>360<sup>o</sup> {t('property.virtualTour')}</strong>
                                                    <br /><span className="btn-link">{t('property.walkThrough')}</span></p>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </>
                            :
                            <>
                            </>
                    }
                    {
                        Checkers.isValidString(factsheetDocument) ?
                            <>
                                <div className="col-sm-6">
                                    <a href={factsheetDocument} target="_blank" rel="noreferrer" className="text-master">
                                        <div className="">
                                            <div
                                                className="profile-img-wrapper m-t-5 d-flex justify-content-center align-items-center b-grey b-a"
                                                style={{width: '55px', height: '55px'}}>
                                                <i className="fa fa-duotone fa-file-pdf fa-2x hint-text"></i>
                                                <div className="chat-status available"></div>
                                            </div>
                                            <div className="inline m-l-10">
                                                <p className="hint-text m-t-10"><strong>{t('property.factSheet')}</strong> <br/><span
                                                    className="btn-link">{t('property.downloadPdf')}</span></p>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </>
                            :
                            <>
                            </>
                    }

                </div>
            </div>
        </>
    )
}